import React, { useState /*,useContext*/ } from 'react';

import './MainAdminNavigation.scss';
import MainAdminHeader from '../MainAdminHeader/MainAdminHeader';
import NavLinks from '../NavLinks/NavLinks';
import Logo from '../Logo/Logo';
import SideDrawer from '../SideDrawer/SideDrawer';
import Backdrop from '../../UIElements/Backdrop/Backdrop';
import Language from '../Language/Language';
// import { LanguageContext } from '../../../context/language-context';

const MainAdminNavigation = (props) => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);

  // const lng = useContext(LanguageContext);

  const openDrawerHandler = () => {
    setDrawerIsOpen(true);
  };

  const closeDrawerHandler = () => {
    setDrawerIsOpen(false);
  };

  return (
    <React.Fragment>
      {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
      <SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
        <nav className="side-drawer__nav--admin">
          <Logo width="80px" height="80px" className="logo--side-drawer" />
          <NavLinks className="nav-links--side-drawer" />
          <Language className="language--side-drawer" />
        </nav>
      </SideDrawer>

      <div className="main-admin-navigation">
        <MainAdminHeader className="main-admin-header">
          <button
            className="main-admin-header__menu-btn"
            onClick={openDrawerHandler}
          >
            <span />
            <span />
            <span />
          </button>
          <nav className="main-admin-header__nav">
            <Logo
              width="100px"
              height="100px"
              className="logo--main-admin-header"
            />
            <div className="main-admin-header__nav-box">
              <NavLinks className="nav-links--admin-header" />
              <Language className="language--admin-header" />
            </div>
          </nav>
        </MainAdminHeader>

        <main className="main-admin-navigation__main">{props.children}</main>
      </div>
    </React.Fragment>
  );
};

export default MainAdminNavigation;
